module.exports = __webpack_public_path__ + "static/media/billing-tax-calculation.8a3ae1f4.svg";